import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';

const DemoDisclaimerPopup = ({ open, onContinue }) => {
  return (
    <Dialog
      open={open}
      onClose={onContinue}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1,
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
        <InfoIcon sx={{ color: '#1976d2', fontSize: 28 }} />
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          Welcome to Mapchise Analytics Demo
        </Typography>
      </DialogTitle>
      
      <DialogContent sx={{ pt: 0, pb: 2 }}>
        <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        The data shown in this demo is entirely fictional and has been generated for demonstration purposes only.
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        This experience highlights the full range of analytics and insights available through our platform.
        </Typography>
        
        <Typography variant="body1" sx={{ lineHeight: 1.6, fontStyle: 'italic', color: '#555' }}>
        All figures, trends, and insights are simulated to showcase how the platform can support real-world business decision-making.
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#1976d2',
            cursor: 'pointer',
            textDecoration: 'underline',
            '&:hover': {
              color: '#1565c0',
            }
          }}
          onClick={() => {
            // Add your contact logic here (e.g., open contact form, redirect to contact page)
            console.log('Contact us clicked');
            window.location.href= 'https://mapchise.com/contact'
          }}
        >
          Contact us to learn more
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onContinue}
          variant="contained"
          size="large"
          sx={{
            backgroundColor: '#1976d2',
            '&:hover': {
              backgroundColor: '#1565c0',
            },
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
          }}
        >
          Continue to Demo
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Usage example component
const OverviewPopup = () => {
  const [showDisclaimer, setShowDisclaimer] = useState(true);

  const handleContinue = () => {
    setShowDisclaimer(false);
    // Add any additional logic here (e.g., analytics tracking)
    console.log('User acknowledged demo disclaimer');
  };

  return (
    <div>
      <DemoDisclaimerPopup 
        open={showDisclaimer} 
        onContinue={handleContinue}
      />
      
    </div>
  );
};

export default OverviewPopup;